export interface Locale {
    lang: string;
    data: any;
  }
  